"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

const ScrollToTop = ({ children }) => {
  const pathname = usePathname(); // Route-ийг шалгах

  useEffect(() => {
    window.scrollTo(0, 0); // Route өөрчлөгдөх бүрт Scroll to Top
  }, [pathname]); // Pathname өөрчлөгдөх үед trigger

  return <>{children}</>;
};

export default ScrollToTop;
